import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import LngLat from "./lng_lat";
var LngLatBounds = /*#__PURE__*/function () {
  function LngLatBounds(sw, ne) {
    _classCallCheck(this, LngLatBounds);
    if (!sw) {
      // noop
    } else if (ne) {
      this.setSouthWest(sw).setNorthEast(ne);
    } else if (sw.length === 4) {
      this.setSouthWest([sw[0], sw[1]]).setNorthEast([sw[2], sw[3]]);
    } else {
      this.setSouthWest(sw[0]).setNorthEast(sw[1]);
    }
  }
  _createClass(LngLatBounds, [{
    key: "setNorthEast",
    value: function setNorthEast(ne) {
      this.ne = ne instanceof LngLat ? new LngLat(ne.lng, ne.lat) : LngLat.convert(ne);
      return this;
    }
  }, {
    key: "setSouthWest",
    value: function setSouthWest(sw) {
      this.sw = sw instanceof LngLat ? new LngLat(sw.lng, sw.lat) : LngLat.convert(sw);
      return this;
    }
  }, {
    key: "extend",
    value: function extend(obj) {
      var sw = this.sw;
      var ne = this.ne;
      var sw2;
      var ne2;
      if (obj instanceof LngLat) {
        sw2 = obj;
        ne2 = obj;
      } else if (obj instanceof LngLatBounds) {
        sw2 = obj.sw;
        ne2 = obj.ne;
        if (!sw2 || !ne2) {
          return this;
        }
      } else {
        if (Array.isArray(obj)) {
          // @ts-ignore
          if (obj.length === 4 || obj.every(Array.isArray)) {
            var lngLatBoundsObj = obj;
            return this.extend(LngLatBounds.convert(lngLatBoundsObj));
          } else {
            var lngLatObj = obj;
            return this.extend(LngLat.convert(lngLatObj));
          }
        }
        return this;
      }
      if (!sw && !ne) {
        this.sw = new LngLat(sw2.lng, sw2.lat);
        this.ne = new LngLat(ne2.lng, ne2.lat);
      } else {
        sw.lng = Math.min(sw2.lng, sw.lng);
        sw.lat = Math.min(sw2.lat, sw.lat);
        ne.lng = Math.max(ne2.lng, ne.lng);
        ne.lat = Math.max(ne2.lat, ne.lat);
      }
      return this;
    }
  }, {
    key: "getCenter",
    value: function getCenter() {
      return new LngLat((this.sw.lng + this.ne.lng) / 2, (this.sw.lat + this.ne.lat) / 2);
    }
  }, {
    key: "getSouthWest",
    value: function getSouthWest() {
      return this.sw;
    }
  }, {
    key: "getNorthEast",
    value: function getNorthEast() {
      return this.ne;
    }
  }, {
    key: "getNorthWest",
    value: function getNorthWest() {
      return new LngLat(this.getWest(), this.getNorth());
    }
  }, {
    key: "getSouthEast",
    value: function getSouthEast() {
      return new LngLat(this.getEast(), this.getSouth());
    }
  }, {
    key: "getWest",
    value: function getWest() {
      return this.sw.lng;
    }
  }, {
    key: "getSouth",
    value: function getSouth() {
      return this.sw.lat;
    }
  }, {
    key: "getEast",
    value: function getEast() {
      return this.ne.lng;
    }
  }, {
    key: "getNorth",
    value: function getNorth() {
      return this.ne.lat;
    }
  }, {
    key: "toArray",
    value: function toArray() {
      return [this.sw.toArray(), this.ne.toArray()];
    }
  }, {
    key: "toString",
    value: function toString() {
      return "LngLatBounds(".concat(this.sw.toString(), ", ").concat(this.ne.toString(), ")");
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return !(this.sw && this.ne);
    }
  }, {
    key: "contains",
    value: function contains(lnglat) {
      var _LngLat$convert = LngLat.convert(lnglat),
        lng = _LngLat$convert.lng,
        lat = _LngLat$convert.lat;
      var containsLatitude = this.sw.lat <= lat && lat <= this.ne.lat;
      var containsLongitude = this.sw.lng <= lng && lng <= this.ne.lng;
      if (this.sw.lng > this.ne.lng) {
        // wrapped coordinates
        containsLongitude = this.sw.lng >= lng && lng >= this.ne.lng;
      }
      return containsLatitude && containsLongitude;
    }
  }], [{
    key: "convert",
    value: function convert(input) {
      if (input instanceof LngLatBounds) {
        return input;
      }
      return new LngLatBounds(input);
    }
  }]);
  return LngLatBounds;
}();
export { LngLatBounds as default };